module.exports = __webpack_public_path__ + "static/media/paso 4.eabd9354.png";